import React, { useState } from 'react';

import PropTypes from 'prop-types';
import { Box, Button, Spinner, StackView, TextArea } from '@telus-uds/components-web';

import request from '../../../../../../../utils/request';
import { useLocalizedStringsContext } from '../../../../../../../context/LocalizedStringsContext';

const AddComment = ({ orderData, setNewCommentAdded }) => {
  const {
    ORDERS: { save }
  } = useLocalizedStringsContext();

  const [comment, setComment] = useState('');
  const [uploadingComment, setUploadingComment] = useState(false);

  const onAddComment = async () => {
    try {
      const { id } = orderData;
      setComment('');
      setUploadingComment(true);
      const result = await request.post(`/orders/${id}/comments`, {
        text: comment
      });
      if (result) {
        setUploadingComment(false);
        setNewCommentAdded(result.data.id);
      }
    } catch (err) {
      setUploadingComment(false);
    }
  };
  return (
    <StackView space={4}>
      <TextArea
        label=""
        id="order-comment"
        value={comment}
        onChange={(value) => setComment(value)}
      />
      <div style={{ display: 'flex', justifyContent: 'center' }}>
        <Spinner
          label="Posting comment..."
          variant={{ size: 'small' }}
          show={uploadingComment}
          inline
        >
          <Button variant={{ priority: 'high' }} onPress={onAddComment}>
            {save}
          </Button>
        </Spinner>
      </div>
    </StackView>
  );
};

AddComment.propTypes = {
  orderData: PropTypes.objectOf(PropTypes.any).isRequired,
  setNewCommentAdded: PropTypes.func.isRequired
};

export default AddComment;
